import {
  SET_HEADER_HEIGHT,
  SET_WINDOW_WIDTH,
  SET_WINDOW_HEIGHT,
  SET_SERVICES_HEIGHT,
  SET_TIZER_HEIGHT,
  SET_CATEGORY_HEIGHT,
  RESET_CATEGORIES_HEIGHT,
} from './types';

export function setHeaderHeight(height: string) {
  return {
    type: SET_HEADER_HEIGHT,
    payload: height,
  };
}

export function setWindowWidth(width: number) {
  return {
    type: SET_WINDOW_WIDTH,
    payload: width,
  };
}

export function setWindowHeight(height: number) {
  return {
    type: SET_WINDOW_HEIGHT,
    payload: height,
  };
}

export function setServicesHeight(height: number) {
  return {
    type: SET_SERVICES_HEIGHT,
    payload: height,
  };
}

export function setTizerHeight(height: number) {
  return {
    type: SET_TIZER_HEIGHT,
    payload: height,
  };
}

export function setCategoryHeight(height: number, id: number) {
  return {
    type: SET_CATEGORY_HEIGHT,
    height,
    id,
  };
}

export function resetCategoriesHeight() {
  return {
    type: RESET_CATEGORIES_HEIGHT,
  };
}
